import { useEffect, useState } from "react";
import {
    setBannerDeliveryWebcamWarningFlag,
    shouldDisplayWebcamWarning,
} from "@utils/bannerUtils";

const useDisplayWebcamWarningFlag = () => {
    const [displayWebcamWarningFlag, setDisplayWebcamWarningFlag] =
        useState(false);

    const getCookie = () => {
        return shouldDisplayWebcamWarning();
    };

    useEffect(() => {
        setDisplayWebcamWarningFlag(getCookie());
    });

    const updateDisplayWebcamWarningFlag = (value: boolean) => {
        setBannerDeliveryWebcamWarningFlag(value);
        setDisplayWebcamWarningFlag(getCookie());
    };

    return [displayWebcamWarningFlag, updateDisplayWebcamWarningFlag] as const;
};

export default useDisplayWebcamWarningFlag;
